import React, { useState } from "react";
import { 
  LANGUAGE_PROFICIENCY_OPTIONS, 
  COMPETENCY_PROFICIENCY_OPTIONS, 
  CALIBRATION_AUTHORITY_OPTIONS, 
  APPROVAL_STATUS_OPTIONS, 
  createEmptyLanguage, 
  createEmptyClientApproval, 
  createEmptyStandard, 
  createEmptyEquipment, 
  createEmptySoftware 
} from "../constants";
import { FaPlus, FaTrash, FaChevronUp, FaChevronDown } from "react-icons/fa";

const Tab4Competencies = ({
  clientApprovalRecords,
  setClientApprovalRecords,
  standardRecords,
  setStandardRecords,
  equipmentRecords,
  setEquipmentRecords,
  softwareRecords,
  setSoftwareRecords,
  languageRecords,
  setLanguageRecords,
  loading,
  addRecord,
  removeRecord,
  handleRecordChange,
  handleRecordFileChange,
  onSubmit,
  onBack
}) => {
  const [expandedSections, setExpandedSections] = useState({
    clientApproval: true,
    standards: true,
    equipment: true,
    software: true,
    languages: true,
  });

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div>
      {/* Section 12: Client Approvals - Commented out */}
      {/* <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("clientApproval")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">✅</span>
              12. Client Approvals
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.clientApproval ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Client-specific approvals and authorizations.
          </p>
        </div>

        {expandedSections.clientApproval && (
          <>
            {clientApprovalRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Client / agency approval #{index + 1}
                  </h4>
                  {clientApprovalRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeRecord(setClientApprovalRecords, index, createEmptyClientApproval)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>
                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Client / agency name</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.client_name}
                      onChange={(e) => handleRecordChange(setClientApprovalRecords, index, "client_name", e.target.value)}
                      placeholder="Client / agency name"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Role / scope approved for</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.role_scope_approved_for}
                      onChange={(e) => handleRecordChange(setClientApprovalRecords, index, "role_scope_approved_for", e.target.value)}
                      placeholder="Role / scope approved for"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Related project</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.related_project}
                      onChange={(e) => handleRecordChange(setClientApprovalRecords, index, "related_project", e.target.value)}
                      placeholder="Related project"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Approval number</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.approval_number}
                      onChange={(e) => handleRecordChange(setClientApprovalRecords, index, "approval_number", e.target.value)}
                      placeholder="Approval number"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Approval date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.approval_date}
                      onChange={(e) => handleRecordChange(setClientApprovalRecords, index, "approval_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Expiry date</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.expiry_date}
                      onChange={(e) => handleRecordChange(setClientApprovalRecords, index, "expiry_date", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Status</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.status}
                      onChange={(e) => handleRecordChange(setClientApprovalRecords, index, "status", e.target.value)}
                      disabled={loading}
                    >
                      {APPROVAL_STATUS_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Evidence</label>
                      <div className="register-stage2-form__file-upload">
                        <input
                          type="file"
                          id={`approval-file-${index}`}
                          className="register-stage2-form__file-input"
                          accept=".pdf,.jpg,.jpeg,.png"
                          onChange={(e) => handleRecordFileChange(setClientApprovalRecords, index, e.target.files?.[0] || null, "evidence_file")}
                          disabled={loading}
                        />
                        <label htmlFor={`approval-file-${index}`} className="register-stage2-form__file-label">
                          <span className="register-stage2-form__file-icon">📄</span>
                          <span>{record.file_name || "Upload evidence"}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="register-stage2-add-btn"
              onClick={() => addRecord(setClientApprovalRecords, createEmptyClientApproval)}
              disabled={loading}
            >
              <FaPlus /> Add client / agency approval
            </button>
            <div className="register-stage2-form__actions register-stage2-form__actions--inline">
              <button
                type="button"
                className="register-stage2-form__btn register-stage2-form__btn--primary"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit Client Approval"}
              </button>
            </div>
          </>
        )}
      </div> */}

      {/* Section 13: Standards */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("standards")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">📐</span>
              13. Standards
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.standards ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Codes, standards and specifications expertise.
          </p>
        </div>

        {expandedSections.standards && (
          <>
            {standardRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Standard / code familiarity #{index + 1}
                  </h4>
                  {standardRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeRecord(setStandardRecords, index, createEmptyStandard)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>
                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Standard</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.standard}
                      onChange={(e) => handleRecordChange(setStandardRecords, index, "standard", e.target.value)}
                      placeholder="API 5L, ISO 9712..."
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Edition</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.edition}
                      onChange={(e) => handleRecordChange(setStandardRecords, index, "edition", e.target.value)}
                      placeholder="Edition"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Proficiency</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.proficiency}
                      onChange={(e) => handleRecordChange(setStandardRecords, index, "proficiency", e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Select...</option>
                      {COMPETENCY_PROFICIENCY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Last used</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.last_used}
                      onChange={(e) => handleRecordChange(setStandardRecords, index, "last_used", e.target.value)}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="register-stage2-add-btn"
              onClick={() => addRecord(setStandardRecords, createEmptyStandard)}
              disabled={loading}
            >
              <FaPlus /> Add standard / code familiarity
            </button>
          </>
        )}
      </div>

      {/* Section 14: Equipment */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("equipment")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">🔧</span>
              14. Equipment
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.equipment ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Equipment and tools proficiency.
          </p>
        </div>

        {expandedSections.equipment && (
          <>
            {equipmentRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Equipment / instrument #{index + 1}
                  </h4>
                  {equipmentRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeRecord(setEquipmentRecords, index, createEmptyEquipment)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>
                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Instrument name</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.instrument_name}
                      onChange={(e) => handleRecordChange(setEquipmentRecords, index, "instrument_name", e.target.value)}
                      placeholder="Ultrasonic thickness gauge"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Make / model</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.make_model}
                      onChange={(e) => handleRecordChange(setEquipmentRecords, index, "make_model", e.target.value)}
                      placeholder="Make / model"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Proficiency</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.proficiency}
                      onChange={(e) => handleRecordChange(setEquipmentRecords, index, "proficiency", e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Select...</option>
                      {COMPETENCY_PROFICIENCY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Last used</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.last_used}
                      onChange={(e) => handleRecordChange(setEquipmentRecords, index, "last_used", e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">Calibration authority claimed</label>
                      <select
                        className="register-stage2-form__select"
                        value={record.calibration_authority}
                        onChange={(e) => handleRecordChange(setEquipmentRecords, index, "calibration_authority", e.target.value)}
                        disabled={loading}
                      >
                        <option value="">Select...</option>
                        {CALIBRATION_AUTHORITY_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="register-stage2-add-btn"
              onClick={() => addRecord(setEquipmentRecords, createEmptyEquipment)}
              disabled={loading}
            >
              <FaPlus /> Add equipment / instrument
            </button>
          </>
        )}
      </div>

      {/* Section 15: Software */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("software")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">💻</span>
              15. Software
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.software ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Software and technical tools proficiency.
          </p>
        </div>

        {expandedSections.software && (
          <>
            {softwareRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Software / digital tool #{index + 1}
                  </h4>
                  {softwareRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeRecord(setSoftwareRecords, index, createEmptySoftware)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>
                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Software / system</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.software_name}
                      onChange={(e) => handleRecordChange(setSoftwareRecords, index, "software_name", e.target.value)}
                      placeholder="AutoCAD, SAP, mobile reporting app..."
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Proficiency</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.proficiency}
                      onChange={(e) => handleRecordChange(setSoftwareRecords, index, "proficiency", e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Select...</option>
                      {COMPETENCY_PROFICIENCY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Years of use</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.years_of_use}
                      onChange={(e) => handleRecordChange(setSoftwareRecords, index, "years_of_use", e.target.value)}
                      placeholder="Years of use"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Last used</label>
                    <input
                      type="date"
                      className="register-stage2-form__input"
                      value={record.last_used}
                      onChange={(e) => handleRecordChange(setSoftwareRecords, index, "last_used", e.target.value)}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="register-stage2-add-btn"
              onClick={() => addRecord(setSoftwareRecords, createEmptySoftware)}
              disabled={loading}
            >
              <FaPlus /> Add software / digital tool
            </button>
          </>
        )}
      </div>

      {/* Section 16: Languages */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("languages")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">🌐</span>
              16. Languages
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.languages ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Language proficiency and communication skills.
          </p>
        </div>

        {expandedSections.languages && (
          <>
            {languageRecords.map((record, index) => (
              <div key={record.id} className="register-stage2-record-card register-stage2-record-card--compact">
                <div className="register-stage2-record-card__header">
                  <h4 className="register-stage2-record-card__title">
                    Language #{index + 1}
                  </h4>
                  {languageRecords.length > 1 && (
                    <button
                      type="button"
                      className="register-stage2-record-card__remove"
                      onClick={() => removeRecord(setLanguageRecords, index, createEmptyLanguage)}
                      disabled={loading}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>

                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Language</label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={record.language}
                      onChange={(e) => handleRecordChange(setLanguageRecords, index, "language", e.target.value)}
                      placeholder="Language"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Speaking</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.speaking}
                      onChange={(e) => handleRecordChange(setLanguageRecords, index, "speaking", e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Speaking</option>
                      {LANGUAGE_PROFICIENCY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Reading</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.reading}
                      onChange={(e) => handleRecordChange(setLanguageRecords, index, "reading", e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Reading</option>
                      {LANGUAGE_PROFICIENCY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">Writing</label>
                    <select
                      className="register-stage2-form__select"
                      value={record.writing}
                      onChange={(e) => handleRecordChange(setLanguageRecords, index, "writing", e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Writing</option>
                      {LANGUAGE_PROFICIENCY_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="register-stage2-add-btn"
              onClick={() => addRecord(setLanguageRecords, createEmptyLanguage)}
              disabled={loading}
            >
              <FaPlus /> Add Language
            </button>
          </>
        )}
      </div>

      {/* Navigation Buttons */}
      <div className="register-stage2-form__actions">
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--outline"
          onClick={onBack}
          disabled={loading}
        >
          ← Previous Tab
        </button>
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--primary"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit & Continue"}
        </button>
      </div>
    </div>
  );
};

export default Tab4Competencies;